<div class="bg-white p-5">
  <h2 class="text-2xl font-bold text-dc-navy mb-6">
    {{ "SERVICES.TITLE" | translate }}
  </h2>

  <!-- top bar -->
  <div
    class="flex flex-col sm:flex-row sm:justify-between items-stretch sm:items-start gap-3 mb-4"
  >
    <!-- favourite switch -->
    <label class="flex items-center gap-2 mb-3 sm:mb-0 text-sm cursor-pointer">
      <input
        type="checkbox"
        class="h-5 w-5 text-dc-navy border-gray-300 accent-dc-navy mt-1"
        [(ngModel)]="showFavOnly"
        (ngModelChange)="onFavOnlyChange($event)"
      />
      <span class="text-dc-navy">{{
        "SERVICES.FAVORITE_SERVICES" | translate
      }}</span>
    </label>

    <!-- search -->
    <div class="ms-auto w-full sm:w-72">
      <div
        class="flex items-center border border-dc-navy text-dc-navy font-light overflow-hidden"
      >
        <input
          type="text"
          [placeholder]="'SEARCH' | translate"
          class="flex-grow px-4 py-2 text-sm focus:outline-none"
          [(ngModel)]="search"
        />
        <button type="button" class="px-4 text-dc-navy">
          <i class="fas fa-search"></i>
        </button>
      </div>
    </div>
  </div>
  <!-- service groups  -->
  @for (group of groupsFiltered; track group) {
  <div class="border p-4 mb-6">
    <!-- group header -->
    @if (group.active) {
    <div class="flex justify-between items-start mb-4">
      <h3 class="text-dc-navy font-semibold">
        <!-- {{ group.groupName | translate }} ({{ group.visibleServices.length }}) -->
        {{ group.parentServiceName}} ({{ group.visibleServices.length }})
      </h3>
      <button
        class="text-dc-dark-blue underline underline-offset-4 text-base"
        (click)="group.isOpen = !group.isOpen"
      >
        {{
          group.isOpen
            ? ("SERVICES.HIDE" | translate)
            : ("SERVICES.SHOW" | translate)
        }}
      </button>
    </div>
    <div>
      <p class="text-sm text-dc-navy!">{{ group.description }}</p>
    </div>
    }
    <!-- list of services -->
    @if (group.isOpen) {
    <div>
      @for ( service of group.visibleServices; track service) {
      <div
        class="border mb-4 p-4 flex flex-col gap-3 sm:flex-row sm:items-center"
      >
        @if (service.active) {
        <!-- title & desc -->
        <div class="flex-1">
          <p class="font-semibold text-dc-navy!">
            <!-- {{ service.serviceName | translate }} -->
            {{ service.serviceNameTranslation | translate }}
          </p>
          <p class="text-sm text-dc-navy!">{{ service.description }}</p>
        </div>
        <!-- actions -->
        <div class="flex gap-3">
          <app-button
            classesName="card-edge-cut-white text-dc-navy"
            [label]="'BUTTONS.PREREQUISITE' | translate"
            (onBtnClick)="viewDetails(service)"
          >
          </app-button>
          <app-button
            classesName="btn-edge-cut"
            [label]="'BUTTONS.START_SERVICE' | translate"
            (onBtnClick)="startService(service)"
          >
          </app-button>
          <!-- favourite toggle -->
          @if (showFavouriteButton) {
            <button
              class="w-5 text-dc-navy"
              (click)="toggleFav(service)"
            >
              @if (service.favourite) {
              <i class="fa-solid fa-star"></i>
              } @if (!service.favourite) {
              <i class="fa-regular fa-star"></i>
              }
            </button>
          }
        </div>
        }
      </div>
      }
    </div>
    }
  </div>
  }

    <!-- service manual -->
  <section class="mt-14 lg:w-[30%]">
    <app-validation-message
      type="default"
      [content]="{
        title: 'SR_DETAIL.RES_MANUAL_BOX.HEAD' | translate,
        message: 'SR_DETAIL.RES_MANUAL_BOX.TEXT' | translate
      }"
      [showbutton]="false"
      [buttonText]="'SR_DETAIL.RES_MANUAL_BOX.LINK' | translate"
      (onBtnClick)="gotoServiceManuals()"
    />
  </section>
</div>
